import React from 'react';
import { FILTER_TYPES_KEYS } from '../../../constants/appraisal-comparison-filter-types';

/**
 * @typedef {object} PracticeCharacterizationGraphTooltipProps
 * @property {boolean} [active]
 * @property {Array<Object>} [payload]
 * @property {*} [label]
 * @property {string} [activeBarType]
 */

/**
 * @param {PracticeCharacterizationGraphTooltipProps} props
 */
const PracticeCharacterizationGraphTooltip = props => {
  const { active, payload, label, activeBarType } = props;
  if (active && payload && payload.length) {
    let satisfied = payload.filter(p => p.dataKey == 'Satisfied')[0];
    let partial = payload.filter(p => p.dataKey == 'Partial')[0];
    let deficient = payload.filter(p => p.dataKey == 'Deficient')[0];
    let namePrefix = '';

    if (activeBarType == FILTER_TYPES_KEYS.Industry) {
      satisfied = payload.filter(p => p.dataKey == 'SatisfiedInd')[0];
      partial = payload.filter(p => p.dataKey == 'PartialInd')[0];
      deficient = payload.filter(p => p.dataKey == 'DeficientInd')[0];
      namePrefix = 'Ind ';
    } else if (activeBarType == FILTER_TYPES_KEYS.Organization) {
      satisfied = payload.filter(p => p.dataKey == 'SatisfiedOrg')[0];
      partial = payload.filter(p => p.dataKey == 'PartialOrg')[0];
      deficient = payload.filter(p => p.dataKey == 'DeficientOrg')[0];

      // assigning exact values instead of scaled values
      if (satisfied) {
        satisfied.value = satisfied.payload.Satisfied;
      }
      if (partial) {
        partial.value = partial.payload.Partial;
      }
      if (deficient) {
        deficient.value = deficient.payload.Deficient;
      }
      namePrefix = 'Org ';
    } else if (activeBarType == '') {
      return null;
    }

    return (
      <div className='tooltip-graph'>
        <p className='header'>{`${payload[0].payload.Acronym + ' ' + label}`}</p>
        {satisfied && (
          <p className='Satisfied'>{`${namePrefix + 'Satisfied'} : ${satisfied.value}`}</p>
        )}
        {partial && <p className='Partial'>{`${namePrefix + 'Partial'} : ${partial.value}`}</p>}
        {deficient && (
          <p className='Deficient'>{`${namePrefix + 'Deficient'} : ${deficient.value}`}</p>
        )}
      </div>
    );
  }

  return null;
};

export default PracticeCharacterizationGraphTooltip;
